import { GetServerSideProps } from 'next';

import Layout from '@/components/layout/LayoutWrapper';
import UpsellLandingWrapper from '@/components/upsellLanding/UpsellLandingWrapper';
import { InitRequest } from '@/hooks/store';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const LifetimeOfferPage = () => {
	return (
		<Layout pageName="lifetime_offer" title="Calm - Lifetime Offer">
			<UpsellLandingWrapper bgImg="/_n/images/landing-pages/annual-offer-bg.webp" />
		</Layout>
	);
};

export default LifetimeOfferPage;

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context, [InitRequest.DEVICE, InitRequest.PRICES], {
		plan: 'lifetime',
	});

	return {
		props: {
			initialState,
		},
	};
};
